import React, { useState } from 'react';
import { useForm } from 'react-final-form';
import {
    required,
    Button,
    SaveButton,
    TextInput,
    BooleanInput,
    useUpdate,
    useNotify,
    FormWithRedirect, SelectInput
} from 'react-admin';
import IconContentEdit from '@material-ui/icons/Edit';
import IconCancel from '@material-ui/icons/Cancel';

import Dialog from '@material-ui/core/Dialog';
import DialogTitle from '@material-ui/core/DialogTitle';
import DialogContent from '@material-ui/core/DialogContent';
import DialogActions from '@material-ui/core/DialogActions';

export const GroupEditButton = ({ record, organizationId, onChange }) => {
    const [showDialog, setShowDialog] = useState(false);
    const [update, { loading, error }] = useUpdate('group', record?.id);
    const notify = useNotify();

    const handleClick = () => {
        setShowDialog(true);
    };

    const handleCloseClick = () => {
        setShowDialog(false);
    };

    const handleSubmit = async values => {
        let payload = {
            id: record.id,
            ...values
        }

        console.log(`group update payload: ${JSON.stringify(payload)}`);

        update(
            {
                payload: {
                    id: payload.id,
                    organizationId,
                    data: {
                        alias: payload.alias,
                        showMode: payload.showMode
                    }
                }
            },
            {
                onSuccess: ({ data }) => {
                    setShowDialog(false);
                    // Update the comment form to target the newly created post
                    // Updating the ReferenceInput value will force it to reload the available posts
                    // form.change('post_id', data.id);
                    onChange();
                },
                onFailure: ({ error }) => {
                    notify(error.message, 'error');
                }
            }
        );
    };

    return (
        <>
            <Button onClick={ handleClick } label="ra.action.edit">
                <IconContentEdit/>
            </Button>
            <Dialog
                fullWidth
                open={ showDialog }
                onClose={ handleCloseClick }
                aria-label="Edit group"
            >
                <DialogTitle>Edit group { record?.alias || "" }</DialogTitle>

                <FormWithRedirect
                    resource="group"
                    save={ handleSubmit }
                    record={ record }
                    render={ ({
                                  handleSubmitWithRedirect,
                                  pristine,
                                  saving
                              }) => (
                        <>
                            <DialogContent>
                                <TextInput
                                    source="alias"
                                    fullWidth
                                />
                                <SelectInput
                                    source="showMode"
                                    fullWidth
                                    label="Режим отображения группы"
                                    helperText="NORMAL - Обычная группа, HIDDEN - Скрыть группу, TRANSPARENT - Прозрачная группа: все элементы группы показываются на месте данной группы"
                                    choices={ [
                                        { id: 0, name: 'NORMAL' },
                                        { id: 1, name: 'HIDDEN' },
                                        { id: 2, name: 'TRANSPARENT' },
                                    ] }/>
                            </DialogContent>
                            <DialogActions>
                                <Button
                                    label="ra.action.cancel"
                                    onClick={ handleCloseClick }
                                    disabled={ loading }
                                >
                                    <IconCancel/>
                                </Button>
                                <SaveButton
                                    handleSubmitWithRedirect={
                                        handleSubmitWithRedirect
                                    }
                                    pristine={ pristine }
                                    saving={ saving }
                                    disabled={ loading }
                                />
                            </DialogActions>
                        </>
                    ) }
                />
            </Dialog>
        </>
    );
}
